export default __webpack_public_path__ + "4c6845b038aca09478da282c8d2de7ca.svg";